<mat-card class="example-card">
    <mat-card-header class="card-header">
      <mat-card-title class="card-titulo">Reporte de Entregas Pend. de Materiales</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>

      <ng-container *ngIf="canView">

        <mat-expansion-panel *ngIf="!isValidating">

          <mat-expansion-panel-header>
            <mat-panel-title class="card-subtitulo">
              <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="searchForm">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Pedido</mat-label>
                  <input matInput type="number" formControlName="PedidoId" placeholder="Nro. Pedido"
                    aria-label="Nro. Pedido" (keyup.enter)="onSearch()">
                </mat-form-field>
              </div>
              <!-- FECHA Desde -->
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Desde</mat-label>
                  <input matInput [matDatepicker]="fechaDesdePicker" formControlName="FechaEntregaPlanificadaDesde"
                     (click)="fechaDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix
                    (click)="clearDate('FechaEntregaPlanificadaDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <!-- FECHA HASTA -->
              <div fxFlex=34 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Hasta</mat-label>
                  <input matInput [matDatepicker]="fechaHastaPicker" formControlName="FechaEntregaPlanificadaHasta"
                     (click)="fechaHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix
                    (click)="clearDate('FechaEntregaPlanificadaHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{'Proveedor' | translate}}*</mat-label>
                  <input type="text" matInput [matAutocomplete]="proveedor" formControlName="Proveedor" style="width: 95%;">
                  <div *ngIf="isProveedorSearching" style="float: right;"><i class="fa fa-spinner fa-spin"></i></div>
                </mat-form-field>
                <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor"
                  (optionSelected)="onSearch()">
                  <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                    {{s.RazonSocial}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!searchForm.controls['Proveedor'].valid && searchForm.controls['Proveedor'].touched">
                  {{ getErrorProveedor() }}
                </mat-error>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}</mat-label>
                  <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                  <mat-select (selectionChange)="onSearch()" formControlName="TipoMaterialId">
                    <mat-option >Todos</mat-option>
                    <mat-option  *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=34 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <input type="text" placeholder="Material" aria-label="Material" matInput [matAutocomplete]="material"
                    formControlName="Material" style="width: 95%;">
                  <div *ngIf="isMaterialAutoSearching" style="float: right;"><i class="fa fa-spinner fa-spin"></i></div>
                </mat-form-field>
                <mat-autocomplete panelWidth="auto" #material="matAutocomplete" [displayWith]="displayMaterial">
                  <mat-option *ngFor="let s of filteredMaterialList" [value]="s">
                    {{s.Nombre}}
                  </mat-option>
                </mat-autocomplete>
              </div>

            </div>

          </form>

        </mat-expansion-panel>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
          <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
          <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
          <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='FechaEntregaPlanificada' type="Date" format="dd/MM/yyyy" headerText='Entrega Planificada' width=90></e-column>
              <e-column field='PedidoId' headerText='Pedido' width=50></e-column>
              <e-column field='ComunidadDestinoNombre' headerText='Comunidad' width=90>
                <ng-template #headerTemplate let-data>
                  {{'Comunidad' | translate}}
                </ng-template>
              </e-column>
              <e-column field='ProveedorNombre' headerText='Proveedor' width=90></e-column>
              <e-column field='MaterialNombre' headerText='Material' width=90></e-column>
              <e-column field='Detalle' headerText='Detalle' width=90></e-column>
              <e-column field='CantidadPendiente' headerText='Cantidad' width=70>
                <ng-template #template let-data>
                  {{data.CantidadPendiente | number: '1.2-2'}} de {{data.Cantidad | number: '1.2-2'}} {{data.MaterialUnidadMedida}}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=90>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 3px" (click)="viewPedido(data.PedidoId)" *ngIf="canViewPedido" title="Ver pedido">
                    <mat-icon>assignment</mat-icon>
                  </a>
                  <a style="cursor: pointer; margin-right: 3px" (click)="viewProveedor(data.ProveedorId)" *ngIf="canViewProveedor" title="Ver proveedor">
                    <mat-icon>account_box</mat-icon>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>

      </ng-container>

    </mat-card-content>
  </mat-card>
